export function CheckIcon() {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      data-testid="check-icon"
    >
      <path
        d="M0.414621 6.78115C0.657193 6.47825 1.08692 6.41301 1.4061 6.61903L1.46873 6.66458L5.59542 8.74992L12.3765 0.334043C12.6063 -0.0104544 13.0711 -0.103476 13.4157 0.126201C13.7603 0.355966 13.8538 0.8216 13.624 1.16625L6.62441 11.6662C6.50789 11.841 6.32299 11.9586 6.11544 11.9909C5.93382 12.0191 5.74868 11.9797 5.59542 11.8816L5.53144 11.8357L0.531186 7.83526L0.473406 7.78452C0.20241 7.51824 0.172142 7.08425 0.414621 6.78115Z"
        fill={"currentColor"}
      />
    </svg>
  );
}
